import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'satisfaction-tracker',
});

export const avaliaDxHubBetsDemoPageRouteRef = createRouteRef({
  id: 'avalia-dxhub-bets-demo-page',
});

export const usersManagerPageRouteRef = createRouteRef({
  id: 'users-manager-page',
});

export const teamsManagerPageRouteRef = createRouteRef({
  id: 'teams-manager-page',
});

export const satisfactionTrackerPageRouteRef = createRouteRef({
  id: 'satisfaction-tracker-page',
});


export const teamSatisfactionDashboard = createRouteRef({
  id: 'teams-satisfaction-dashboard'
})

export const personalSatisfactionTracker = createRouteRef({
  id: 'personal-satisfaction-tracker'
})

export const homePage = createRouteRef({
  id: 'home-page'
})
